
import store_prestation from '@/store/mods/clinique/prestations'
import $ from 'jquery'

export default {
    name: 'l-acte',
    components: {},
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_load_error: false,
            all_checked: false,
            one_is_checked: [],
            actes: [],
        }
    },
    
    computed: {

    },

    mounted() {
        this.fetchActes()
    },

    methods: {
        fetchActes() {
            this.is_loading = true
            this.is_load_error = false

            store_prestation.getTarifActe('acte').then((response) => {
                this.actes = response
                this.is_empty = this.actes.length === 0
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_load_error = true
            })
        },

        toutSelectionner() {
            const is_checked = $('#acte-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = this.actes.map((acte) => ({ id: acte.id, libelle: acte.acte }))
            } else {
                this.one_is_checked = []
            }

            this.all_checked = is_checked
        },
    }
}